// Font Awesome icon index shared by the TinyMCE icon plugin and the OMP icon picker.

export const OMP_ICON_INDEX_URL = '/assets/omp-icons/icons.json';

export interface OmpIconMatch {
  style: string;
  name: string;
  unicode: string;
  label: string;
}

let indexRequest: Promise<any> = null;

export function loadOmpIconIndex(): Promise<any> {
  if (!indexRequest) {
    indexRequest = fetch(OMP_ICON_INDEX_URL).then((response) => {
      if (!response.ok) {
        throw new Error('Icon index request failed: ' + response.status);
      }
      return response.json();
    });
    indexRequest.catch(() => {
      indexRequest = null;
    });
  }
  return indexRequest;
}

export function searchOmpIcons(index: any, style: string, pattern: string): OmpIconMatch[] {
  const query = (pattern || '').trim().toLowerCase();
  const matches = ([name, , label, terms]: string[]) => {
    const haystack = [name, label.toLowerCase(), terms];
    return !query || haystack.some((text) => text.indexOf(query) !== -1);
  };
  const entries = index && index[style] ? index[style] : [];
  return entries.filter(matches).map(([name, unicode, label]) => ({ style, name, unicode, label }));
}

export function ompIconClass(style: string, name: string): string {
  return 'fa-' + style + ' fa-' + name;
}

export function parseOmpIconClass(icon: string): { style: string; name: string } {
  let parsed = null;
  const parts = (icon || '').split(' ').filter((part) => part.indexOf('fa-') === 0);
  if (parts.length === 2) {
    parsed = { style: parts[0].slice(3), name: parts[1].slice(3) };
  }
  return parsed;
}

export function findOmpIcon(index: any, icon: string): OmpIconMatch {
  let found = null;
  const parsed = parseOmpIconClass(icon);
  const entries = parsed && index && index[parsed.style] ? index[parsed.style] : [];
  entries.forEach(([name, unicode, label]) => {
    if (!found && name === parsed.name) {
      found = { style: parsed.style, name, unicode, label };
    }
  });
  return found;
}

export function ompIconChar(unicode: string): string {
  return String.fromCharCode(parseInt(unicode, 16));
}
